import { render, staticRenderFns } from "./BackLogin.vue?vue&type=template&id=6de65fd8&scoped=true"
import script from "./BackLogin.vue?vue&type=script&lang=js"
export * from "./BackLogin.vue?vue&type=script&lang=js"
import style0 from "./BackLogin.vue?vue&type=style&index=0&id=6de65fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de65fd8",
  null
  
)

export default component.exports